// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.v-toolbar__content .v-btn.v-btn--icon.v-size--default[data-v-001ac414],\n.v-toolbar__extension .v-btn.v-btn--icon.v-size--default[data-v-001ac414] {\n  height: auto;\n  width: auto;\n  padding: 0 0.2rem;\n}\n.v-application--is-ltr .v-toolbar__content > .v-btn.v-btn--icon[data-v-001ac414]:last-child,\n.v-application--is-ltr .v-toolbar__extension > .v-btn.v-btn--icon[data-v-001ac414]:last-child {\n  margin: 0 !important;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
